import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=6dbaf9ab&scoped=true&"
import script from "./Bet.vue?vue&type=script&lang=js&"
export * from "./Bet.vue?vue&type=script&lang=js&"
import style0 from "./Bet.vue?vue&type=style&index=0&id=6dbaf9ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbaf9ab",
  null
  
)

export default component.exports